export default __webpack_public_path__ + "static/media/send-receive.876dec6f.svg";